import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-left",
  "use": "icon_chevron-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon_chevron-left\"><path d=\"M5.253 11.223l8.901-8.901a1.1 1.1 0 011.555 0l1.038 1.038a1.1 1.1 0 01.002 1.553L9.694 12l7.054 7.087c.428.43.427 1.124-.002 1.553l-1.038 1.038a1.1 1.1 0 01-1.554 0l-8.901-8.901a1.1 1.1 0 010-1.554z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol